import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from './security/security.service';


/*
 * Authentication Guard
 *
 * TECHNOLOGY:
 * Implements Angular's 'CanActivate' interface. This service acts as a gatekeeper for routes.
 * It is added to the 'canActivate' array in route definitions (app-routing.module.ts).
 *
 * FUNCTIONALITY:
 * 1. intercepts navigation to a protected route.
 * 2. Checks if the user is logged in (via SecurityService).
 * 3. Returns 'true' to allow navigation, or 'false' to block it.
 * 4. Redirects unauthenticated users to the Login page.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private authSvc: SecurityService, private router: Router) {

  }

  /*
   * TECHNOLOGY: Interface Implementation
   * This method matches the signature required by the CanActivate interface.
   * Angular Router calls this method before activating the route.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authSvc.loggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

}
